import CustomTable, {
  TABLE_SCROLL_HEIGHT,
} from "@/shared/components/ui/Button/CustomTable";
import PaginationInfo from "@/shared/components/ui/Pagination/PaginationInfo";
import SearchBar from "@/shared/components/ui/SearchBar/SearchBar";
import { useCallback, useMemo, useState } from "react";
import { useFetchUsersList, useReviewTrialRequest } from "@/shared/hooks";
import Loader from "@/shared/components/ui/Loaders/Loader";
import {
  ACCESS_REQUEST_COLUMNS,
  createAccessRequestRenderCell,
} from "@/shared/utils/commonConfigs";

const MembersList = () => {
  const [filterValue, setFilterValue] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const { mutate: reviewTrialRequest, isPending: isPendingReviewTrialRequest } =
    useReviewTrialRequest();

  const { data: allUserList, isLoading } = useFetchUsersList({
    limit: 100,
    offset: 0,
    enabled: true,
  });

  const handleReviewTrialRequest = useCallback(
    (userId, action) => reviewTrialRequest({ userId, action }),
    [reviewTrialRequest],
  );

  const accessRequestRenderCell = useMemo(
    () =>
      createAccessRequestRenderCell(
        handleReviewTrialRequest,
        isPendingReviewTrialRequest,
      ),
    [handleReviewTrialRequest, isPendingReviewTrialRequest],
  );

  const onSearchChange = (value) => {
    setFilterValue(value);
    setPage(1);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh-200px)]">
        <Loader text="Loading Members List..." />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-[1.375rem] text-gray-800 font-bold">Members</h1>
      <div className="rounded-xl p-4 bg-white shadow w-full h-[calc(100dvh-90px)]">
        <div className="flex flex-col gap-4 w-full h-full">
          <div className="flex justify-between items-center gap-4">
            <div className="flex gap-2 items-center w-full">
              <SearchBar
                value={filterValue}
                setFilterValue={setFilterValue}
                onChange={onSearchChange}
                placeholder="Search members..."
                className="max-w-[280px]"
              />
              <PaginationInfo
                totalCount={allUserList?.length}
                currentPage={page}
                rowsPerPage={rowsPerPage}
                itemName="member"
              />
            </div>
          </div>

          {allUserList?.length > 0 ? (
            <CustomTable
              columns={ACCESS_REQUEST_COLUMNS}
              data={allUserList}
              renderCell={accessRequestRenderCell}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              totalCount={allUserList?.length}
              page={page}
              onPageChange={setPage}
              height={TABLE_SCROLL_HEIGHT}
            />
          ) : (
            <div className="bg-white rounded-xl border border-gray-200 p-12 text-center">
              <p className="text-gray-500">No members found.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MembersList;
